import React from "react"
import Layout from "../components/layout"
import { graphql } from "gatsby"
import Seo from "../components/seo"
import { LocalBusinessJsonLd } from 'gatsby-plugin-next-seo';

import Header from "../components/header"
import Story from "../components/story"
import Uryslygi from "../components/uryslygi"
import Sdelka  from "../components/sdelka"
import Price from "../components/price"
import Catalog from "../components/catalog"

import OtzivAudio from "../components/otzivAudio"
import OtzivVideo from "../components/otzivVideo"
import OtzivSocial from "../components/otzivSocial"
import OtzivBlank from "../components/otzivBlank"
import OtzivMap from "../components/otzivMap"
import Social from "../components/social"
import Certificate from "../components/certificate"
import Users from "../components/users"

import Blog from "../components/blog"
import Text from "../components/text"
import Map from "../components/map"

import ContactForm from "../components/contactForm"
import Call from "../components/call"
import Sale from "../components/sale"
import CallForm from "../components/callForm"
import Stado from "../components/stado"
import Policy from "../components/policy"

export const query = graphql `
	query  {
		blogs: allBlog(sort: { order: DESC, fields: datePublished }, limit: 10) {
			edges {
			  node {
				slug
				title
				description
				card
				img
				imgMini
				date
				seoTitle
				seoDescription
				author
				ava
				time
			  }
			} 
		}
	}
`

const IndexPage = ({data}) => {
	return (
		<Layout>
			<Seo title="Составление договоров | Юридическая компания | Алмаз" description="! ⚖️ «Алмаз» ➥ ⭐ Каждый договор индивидуален и имеет свои особенности, существенные условия договора, которые необходимо учитывать при его составлении." />

			<LocalBusinessJsonLd
				type='Store'
				id='https://юридические-услуги-казань.рф/sostavlenie-dogovorov'
				name="Составление договоров | Юридическая компания | Алмаз"
				description="! ⚖️ «Алмаз» ➥ ⭐ Каждый договор индивидуален и имеет свои особенности, существенные условия договора, которые необходимо учитывать при его составлении."
				url='https://юридические-услуги-казань.рф'
				telephone='+78005519518'
				address={{
					streetAddress: 'Щапова, 26',
					addressLocality: 'Казань',
					addressRegion: 'Татарстан',
					postalCode: '420012',
					addressCountry: 'RU',
				}}
				geo={{
					latitude: '55.791461',
					longitude: '49.136606',
				}}
				images={[
					'https://юридические-услуги-казань.рф/img/logo.png'
				]}
			/>

			<Header title="Составление договоров" card="Сомневаетесь, что хороший юрист Вам по карману? Не знаете, как подготовиться к судебному процессу и защитить свои права? Запутались в законах и не знаете, как грамотно сформулировать претензию ?" />
			<Story />
			<Uryslygi />
			<Sdelka />
			<Price />
			<Catalog />
			<OtzivAudio />
			<OtzivVideo />
			<OtzivSocial />
			<OtzivBlank />
			<OtzivMap />
			
			<Social />
			<Certificate />
			<Users />

			<Blog data={data.blogs} />

			<Text 
				title={"Составление договоров"}
			
				html={

				`

				<p class="TextText">
				При составлении договора в Казани все участники должны дать свое согласие и предоставить свои условия сделки. В случае оформления недвижимости также необходимо правильное составление всех документов. Участники могут быть представлены как физическими лицами, так и юридическими, а также и разнообразные государственные организации, к которым относятся органы муниципальной власти, международные компании и т.д. Можно определить в трех значениях: договор в качестве отношения правового характера, возникающего между сторонами; юридический случай, который порождает некую ответственность; документ, определяющий начало появления ответственности между сторонами с их согласия.
				</p>

				<p class="TextText">
				Многие слабо квалифицированные юристы чаще всего осуществляют составление договора в Казани из образцов, скаченных в сети «интернет» либо с информационно-правовых систем. Использование подобных «договоров» в хозяйственной или частной деятельности может повлечь за собой серьезные негативные правовые последствия: признание договора незаключённым либо недействительным, невозможность привлечь контрагента к ответственности за невыполнение условий договора. Каждый договор индивидуален и имеет свои особенности, существенные условия договора, которые необходимо учитывать при его составлении. При составлении договора нашими специалистами учитывается актуальная судебная практика по разрешению возникающих по данному виду договора споров, что помогает в дальнейшем избежать проблем. Если Вы хотите, чтобы ваш бизнес приносил Вам только радость, то лучше обратиться в юридическую компанию Алмаз, которая поможет правильно составить договор. Обращайтесь в нашу юридическую компанию за составлением правильного Договора (Соглашения), соответствующего законодательству России, любой сложности и мы выполним данную работу надлежащим образом.
				</p>

				<p class="TextText">
					<b>Правильное составление договоров</b>
				</p>

				<p class="TextText">
				Договор принято считать наиболее популярным и продуктивным способом, позволяющим урегулировать любые взаимоотношения во многих сферах жизни, и он используется уже в течение многих лет в разных странах всего мира.

				Но главное, чтобы договор имел законную силу и не доставлял ненужных проблем и возникающих из-за этого рисков, лучше всего прибегнуть к помощи профессиональных юристов, которые оказывают различные юридические услуги и имеют опыт составления юридического письма. В нашей компании работают только профессионалы данной отрасли, которые помогут не только создать текст, но также будут участвовать в переговорах, а на последующих этапах проследят за выполнением оговоренных соглашений.
				
				Составление договоров в Казани во всех отраслях деятельности должны осуществлять только опытные специалисты, имеющие необходимые правовые знания. Этот вид документа имеет очень большое значение при решении вопросов взаимодействия в рыночной отрасли, и его правильное составление имеет огромное значение.
				</p>

				<p class="TextText">
				Правильно составленный договор должен иметь следующие пункты: последствия налогового характера; налоговый статус сторон, заключающих договор; дату заключения;
				время, когда право собственности переходит другому лицу; дату оплаты; цену приобретаемого товара.
				Для планирования налогового бремени данные пункты будут иметь большое значение. Допустим, если составляется договор подряда, то там должны быть правильно указаны виды работ: ремонт (в данном случае расходы можно будет списать на себестоимость) либо усовершенствование (тогда расходы относятся к амортизационным). Строительная фирма, осуществляющая данные работы, не имеет знаний в данных вопросах, а бухгалтер не во всех случаях может должным образом оценить ситуацию. Чтобы в дальнейшем не возникло никаких проблем, то составление договора в Казани должно происходить правильно, а также правильная смета, дефектная ведомость.
				</p>

				<p class="TextText">
				Мы можем предложить юридическим лицам услуги по абонентскому обслуживанию организаций, таким образом Вы всегда будете уверены в правильности выполнения любого дела.

				Наша компания уверена, что при этом необходимо знание всех сторон сделки, возникающей ответственности и профессионального подхода, только тогда результат будет положительным. Поэтому мы можем:
				
				определить вид договора, который необходимо составить, исходя из условий, по которым сотрудничают 2 или более контрагента;
				составить проект договора, учитывая все тонкости сделки.
				Моделирование договоров – это очень сложная отрасль, требующая от сторон обширных знаний в разнообразных сферах человеческой жизни, профессионализма по решению сложных вопросов, знание меняющихся законов, а также наличие опыта, связанного с решением ситуаций конфликтного характера.
				</p>

				`

			}/>

			<Map />

			<ContactForm />
			<Sale />
			<Call />
			<CallForm />
			<Stado />
			<Policy />
		</Layout>
	)
}


export default IndexPage
